export enum ParticipantDocumentApprovalStatusEnum {
    Unknown = 0,
    Approved = 1,
    Denied = 2,
}
